export const ZOOM_CHAT = {
    API_KEY: 'BwxQFdNDRBy1twW2iKcINg',
    REGION: 'us01',
    SCRIPT_ID: 'zoomChatScript',
    SKU: 'asktheprochat',
    SDK_URL: 'https://us01ccistatic.zoom.us/us01cci/web-sdk/zcc-sdk.js',
};
